import React from "react";
import PropTypes from "prop-types";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Social, { SocialLink } from "@ui/social";
import { FaOrcid } from 'react-icons/fa';
import { SiGooglescholar } from 'react-icons/si';
import { FaBlog } from 'react-icons/fa';
import {
	TeamMemberWrap,
	TeamMemberInner,
	TeamMemberImage,
	TeamMemberSocialWrap,
	TeamMemberInfo,
	TeamMemberName,
	TeamMemberDesignation
} from './team-member.style'

const TeamMember = ({ imageSrc, name, designation, social, ...restProps }) => {
	const { nameStyle, roleStyle, infoStyle, socialStyle, wrapperStyle, ...restStyles } = restProps;
	const { scholar, orcid, web } = social;
	let teamImg;
	if (typeof imageSrc === 'object') {
		teamImg = <GatsbyImage image={getImage(imageSrc)} alt={name || 'Team Member'} />;
	} else {
		teamImg = <img src={imageSrc} alt={name || 'Team Member'} />
	}
	const containsDirector = designation && designation.toLowerCase().includes('director');
	return (
		<TeamMemberWrap {...wrapperStyle} {...restStyles}>
			<TeamMemberInner>
				<TeamMemberImage>
					{teamImg}
					{social && (
						<TeamMemberSocialWrap>
							<Social {...socialStyle}>
								{scholar && <SocialLink title="Google Scholar" path={scholar}><SiGooglescholar /></SocialLink>}
								{orcid && <SocialLink title="ORCID" path={orcid}><FaOrcid /></SocialLink>}
								{web && <SocialLink title="Personal HomePage" path={web}><FaBlog /></SocialLink>}
							</Social>
						</TeamMemberSocialWrap>
					)}
				</TeamMemberImage>
				<TeamMemberInfo {...infoStyle} style={{marginTop:"27px"}}>
					{name && <TeamMemberName {...nameStyle}>{name}</TeamMemberName>}
					{designation && <TeamMemberDesignation isBold={containsDirector} {...roleStyle}>{designation}</TeamMemberDesignation>}
				</TeamMemberInfo>
			</TeamMemberInner>
		</TeamMemberWrap>
	)
}

TeamMember.propTypes = {
	imageSrc: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.string
	]),
	name: PropTypes.string,
	designation: PropTypes.string,
	social: PropTypes.object,
	layout: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	socialStyle: PropTypes.object
}

TeamMember.defaultProps = {
	layout: 1,
	socialStyle: {
		skin: 'light',
		tooltip: true,
		hover: {
			color: '#fff'
		}
	},
	social: {}
}

export default TeamMember;